/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./StakeRecord.vue?vue&type=template&id=a5670ffe&scoped=true"
import script from "./StakeRecord.vue?vue&type=script&lang=js"
export * from "./StakeRecord.vue?vue&type=script&lang=js"
import style0 from "./StakeRecord.vue?vue&type=style&index=0&id=a5670ffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5670ffe",
  null
  
)

export default component.exports